import { TemplateRef } from '@angular/core';
import { CentroLogisticoCementoVm } from '../../../models/centro-logistico-cemento.vm';
import { AdminServerTableCellContext, AdminServerTableColumn } from '../../../shared/table/models/admin-server-table.model';

interface CentrosLogisticosColumnsTemplates {
  actionsCellTemplate: TemplateRef<AdminServerTableCellContext<CentroLogisticoCementoVm>>;
}

export function buildCentrosLogisticosCementoColumns(
  templates: CentrosLogisticosColumnsTemplates,
): AdminServerTableColumn<CentroLogisticoCementoVm>[] {
  return [
    {
      id: 'puestoExploracion',
      header: 'Puesto exploración',
      sortable: true,
      sortKey: 'puesto_exploracion',
      cellClass: 'admin-col-nowrap',
      value: (row) => row.puestoExploracion,
      title: (row) => row.puestoExploracion,
    },
    {
      id: 'centro',
      header: 'Centro',
      sortable: true,
      sortKey: 'centro',
      cellClass: 'admin-col-nowrap',
      value: (row) => row.centro,
      title: (row) => row.centro,
    },
    {
      id: 'centroNombre',
      header: 'Centro nombre',
      sortable: true,
      sortKey: 'centro_nombre',
      headerClass: 'admin-col-truncate-md',
      cellClass: 'admin-col-truncate-md',
      value: (row) => row.centroNombre,
      title: (row) => row.centroNombre,
    },
    {
      id: 'planta',
      header: 'Planta',
      sortable: true,
      sortKey: 'planta',
      headerClass: 'admin-col-truncate-sm',
      cellClass: 'admin-col-truncate-sm',
      value: (row) => row.planta,
      title: (row) => row.planta,
    },
    {
      id: 'acciones',
      header: 'Acciones',
      sortable: false,
      headerClass: 'admin-col-actions',
      cellClass: 'admin-col-actions',
      cellTemplate: templates.actionsCellTemplate,
      title: () => '',
    },
  ];
}
